<template>
  <div class="login_container">
    <div class="welcome">途宇行后台管理系统</div>
    <div class="login_box">
      <!-- 头像区域 -->
      <div class="avatar_box">
        <img src="../assets/image/logo.png" />
      </div>
      <!-- 登陆表单区域 -->
      <el-form label-width="0px" class="login_form" :model="LoginForm" :rules="LoginFormRules" ref="loginFormRef">
        <!-- 用户名区域 -->
        <el-form-item prop="username">
          <el-input prefix-icon="iconfont icon-yonghu" v-model="LoginForm.username" style="padding-left: 26px !important;"></el-input>
        </el-form-item>
        <!-- 密码区域 -->
        <el-form-item prop="password">
          <el-input prefix-icon="iconfont icon-mima" type="password" v-model="LoginForm.password" style="padding-left: 26px !important;"></el-input>
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button style="background-color: #3CA757;color: #FFFFFF;" @click="login">登陆</el-button>
          <el-button type="info" @click="loginFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      LoginForm: {
        username: '',
        password: '',
      },
      //这是表单验证规则
      LoginFormRules: {
        //验证用户名是否合法
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 16,
            message: '长度在 3 到 16 个字符',
            trigger: 'blur',
          },
        ],
        //验证密码是否合法
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 16,
            message: '长度在 3 到 16 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    loginFormReset() {
      //重置表单  loginFormRef 表单的引用  resetFields 重置表单方法
      this.$refs.loginFormRef.resetFields()
    },
    login() {
      //登陆时对表单的再次验证
      this.$refs.loginFormRef.validate(async (valid) => {
        //如果验证失败直接返回
        if (!valid) return
        //表单验证通过 发出请求
        const { data: res } = await this.$http.post('/system/user/loginWithRole', {
          username: this.LoginForm.username,
          password: this.LoginForm.password,
        })
        if (res.code != 200) return this.$message.error(res.msg)
        else this.$message.success(res.msg)
        //1.将登陆成功后的token 保存到客户端的sessionStorage 中
        //	1.1 项目中除了登陆  其他接口访问时，也需要携带token信息才能访问
        //	1.2 token只应在当前网站打开期间有效 所以讲token保存在sessionStorage中
        window.sessionStorage.setItem('token', res.data.token);
        window.sessionStorage.setItem('user', res.data.username);
        window.sessionStorage.setItem('userId', res.data.userId);
        window.sessionStorage.setItem('roles', JSON.stringify(res.data.roles));
        window.sessionStorage.setItem('roleCodes', JSON.stringify(res.data.roleCodes || []));
        window.sessionStorage.setItem('permissions', JSON.stringify(res.data.permissions || []));
        window.sessionStorage.setItem('isAdmin', res.data.isAdmin);
        this.$router.push({ path: '/home' })
      })
    },
  },
}
</script>

//添加scoped 则只在本文件中生效
<style scoped>
.login_container {
  /* background-image: url(../assets/image/login.png); */
  background-size: 100%;
  background-color: #2b4b6b;
  height: 100%;
}

.login_box {
  width: 28.125rem;
  height: 18.75rem;
  background-color: #fff;
  border-radius: 0.1875rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.login_container .avatar_box {
  height: 8.125rem;
  width: 8.125rem;
  border: 0.0625rem solid #eee;
  border-radius: 50%;
  padding: 0.625rem;
  box-shadow: 0 0 0.625rem #ddd;
  /* 添加阴影 */
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
}

.login_container .avatar_box img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #eee;
}

.login_form {
  position: absolute;
  bottom: 0rem;
  width: 100%;
  padding: 0 1.25rem;
  box-sizing: border-box;
  /* 设置padding时 不增加总宽度 减少总宽度来满足padding设置的间距 */
}

.btns {
  display: flex;
  justify-content: flex-end;
}

.welcome {
  font-size: 28px;
  position: absolute;
  left: 50%;
  top: 20%;
  transform: translate(-50%, -20%);
  color: #eee;
}

.icp-info {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #999;
  font-size: 12px;
}

.icp-info a {
  color: #999;
  text-decoration: none;
}

.icp-info a:hover {
  color: #3CA757;
}
</style>
